/**
 * HEAD の応答を待つ上限。一覧の取得はこの計測を待つので、応答が返らないまま止まると一覧も止まる
 */
const SERVER_TIME_HEAD_TIMEOUT_5_SECONDS_MS = 5_000;

/**
 * 自オリジンへの HEAD の Date ヘッダをサーバー時刻とし、往復の中間時点の端末時刻との差を取る。
 * Date ヘッダは秒単位なので、誤差は往復時間の非対称と合わせて 1〜2 秒程度になる。
 */
const measureServerTimeOffsetMs = async (): Promise<number> => {
  // 対象ブラウザに AbortSignal.timeout の無い iOS 15 を含むので、AbortController で打ち切る
  const controller = new AbortController();
  const timeoutId = setTimeout(
    () => controller.abort(),
    SERVER_TIME_HEAD_TIMEOUT_5_SECONDS_MS
  );
  try {
    const begin = Date.now();
    const response = await fetch(window.location.origin, {
      method: "HEAD",
      cache: "no-store",
      signal: controller.signal,
    });
    const end = Date.now();
    const serverTime = Date.parse(response.headers.get("Date") ?? "");
    if (Number.isNaN(serverTime)) {
      throw new Error("Date ヘッダからサーバー時刻を読み取れませんでした");
    }
    return serverTime - (begin + end) / 2;
  } finally {
    clearTimeout(timeoutId);
  }
};

let serverTimeOffsetMs: number | null = null;

/**
 * サーバー時刻 − 端末時刻（ミリ秒）
 *
 * 端末の時計はずれていることがあるので、サーバーと時刻を比べる箇所はこの差で補正する。
 * 計測できた値は、ページを開いている間使い回す。最初の計測が終わる前に呼ばれた分は、それぞれが
 * 計測する。計測に失敗したとき（HEAD が 5 秒以内に返らないときを含む）は 0（端末の時刻を
 * そのまま使う）を返し、次の呼び出しで計測し直す。
 */
export const getServerTimeOffsetMs = async (): Promise<number> => {
  if (serverTimeOffsetMs !== null) return serverTimeOffsetMs;
  try {
    serverTimeOffsetMs = await measureServerTimeOffsetMs();
    return serverTimeOffsetMs;
  } catch (error) {
    console.error(error);
    return 0;
  }
};
